export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8398.eb296e07.jpg";